const emailRegex = /.+@.+\..+/;
export default emailRegex;

/**
 *
 * @param {String} emailString - The string that will be tested.
 * @returns {Boolean} - The result from the regex test
 */
export const isEmail = (emailString) => emailRegex.test(emailString);
